// extracted by mini-css-extract-plugin
export default {"RelationshipsListAllModal_TitleCounter":"RelationshipsListAllModal-module__RelationshipsListAllModal_TitleCounter--BnybY"};